import React from 'react';

import { HomeDaypartGreeting } from 'features/home/components/home-daypart-greeting/home-daypart-greeting';
import { HomePageView } from 'features/home/components/home-page/home-page.view';
import { useFeatureHomePage } from 'features/home/components/home-page/use-feature-home-page';

import { PageAnnouncer } from 'components/ui/page-announcer';
import { PromoMessageRibbon } from 'pages/loyalty/loyalty-promo-message-ribbon';
import { t } from 'state/intl/translations';

// Keep the CMS query composition mounted beneath the page shell.
const HomeContent = ({ headerComponent }: { headerComponent?: React.ReactElement | null }) => {
  const { featureHomePageLoading, featureHomePage } = useFeatureHomePage();

  return (
    <HomePageView
      isLoading={featureHomePageLoading}
      featureHomePage={featureHomePage}
      headerComponent={headerComponent}
    />
  );
};

const HomePage = () => {
  return (
    <>
      <PromoMessageRibbon exposureScope="home" skipStoreDayPartHours />
      <HomeContent headerComponent={<HomeDaypartGreeting />} />
      <PageAnnouncer pageTitle={t('homepage')} />
    </>
  );
};

export default React.memo(HomePage);
